import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { graphConfig, msalConfig } from './authConfig';
import PubSub from 'pubsub-js'
import { message } from 'antd';
import { login } from '../Http/service';
import { setStorage, getStorage } from './utils';
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */

const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    // const account = event.payload.account;
    // msalInstance.setActiveAccount(account);
    const payload = event.payload;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

msalInstance
  .handleRedirectPromise()
  .then(async (tokenResponse) => {
    // 檢查URL參數中是否有from和version參數
    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');
    const versionParam = urlParams.get('version');
    if (fromParam) {
      sessionStorage.setItem('from', fromParam);
    }
    if (versionParam) {
      sessionStorage.setItem('version', versionParam);
    }

    if (tokenResponse) {
      const { accessToken } = tokenResponse;
      if (accessToken) {
        //如果已經登錄過, 走後端的登錄接口, 獲取新的token
        localStorage.setItem("accessToken", accessToken);
        // setStorage("userName", tokenResponse.account.name);
        setStorage("userMail", tokenResponse.account.username);
        localStorage.setItem("aadStatus", 'true');
        const param = {
          email: tokenResponse.account.username,
          accessToken: accessToken,
          name: tokenResponse.account.name
        };
        const data = await login(param);
        if (data.result === "ok") {
          localStorage.setItem("qxqwqsf_d7w2c6", data.token);
          localStorage.setItem("myName", data.data.nickname);
          localStorage.setItem("Language", data.data.language);
          setStorage("idNumber", data.data.client_id);
          setStorage("userRole", data.data.role);
          localStorage.setItem("sex", data.data.sex);
          PubSub.publish('userLoggedIn', {
            myName: data.data.nickname,
            language: data.data.language,
            idNumber: data.data.client_id,
            userRole: data.data.role
          })
          if (localStorage.getItem("redirectUri")) {
            window.location.replace(localStorage.getItem("redirectUri"));
            // localStorage.removeItem("redirectUri");
          }
          // 如果不是從 Windows app 登入，才顯示一般登入成功訊息
          if (sessionStorage.getItem("from") !== "Windows") {
            message.success("You have successfully logged in.");
          }
        } else {
          //code为1可以申请权限，为2时不可以申请  3为等待状态
          if (data.code === 1) {
            message.error("You do not currently have permission to access this page. To request access, please apply for permissions.",4);
            localStorage.clear();
            window.location.replace("authority");
            localStorage.setItem("name", data.name);
            localStorage.setItem("email", data.email);
            localStorage.setItem("qxqwqsf_d7w2c6", data.token);
            setStorage("idNumber", data.clientID);
          }else if(data.code===3){
            message.error("Your application is pending review. Please do not submit repeatedly.", 4);
            localStorage.clear();
            setTimeout(() => {
              window.location.replace("login");
            }, 1500)
          }
           else {
            message.error("You do not have permissions to access this page. Please contact the administrator for assistance.", 4);
            localStorage.clear();
            setTimeout(() => {
              window.location.replace("login");
            }, 1500)
          }
        }
      }
    } else {
      const refreshParams = {
        accessToken: localStorage.getItem("accessToken"),
        token:localStorage.getItem("qxqwqsf_d7w2c6"),
        email: getStorage("userMail"),
      }

      if (accounts.length > 0) {
        const data = await login(refreshParams);
        if (data.result === "ok" && refreshParams.token) {
          // 只有在非 Windows app 登入且在 home 頁面時才顯示訊息
          if (window.location.pathname === "/home" && sessionStorage.getItem("from") !== "Windows") {
            message.success("You have successfully logged in.");
          }
        } else {
          message.error("Token not found, please login again.");
          setTimeout(() => {
            localStorage.clear();
            window.location.href = "login";
            console.error('login error !');
          }, 3000);
        }
      } else {
        // 如果沒有accounts，檢查URL參數並設置from和version到sessionStorage
        const urlParams = new URLSearchParams(window.location.search);
        const fromParam = urlParams.get('from');
        const versionParam = urlParams.get('version');
        if (fromParam) {
          sessionStorage.setItem('from', fromParam);
        }
        if (versionParam) {
          sessionStorage.setItem('version', versionParam);
        }
      }
    }
  })
  .catch((error) => {
    // Handle redirect error
    console.error('msalInstance error--', error);
  });

const getAadAccessToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  const accessTokenRequest = {
    scopes: ['user.read'],
    account: accounts[0],
  };

  // let token = localStorage.getItem(ACCESS_TOKEN);
  const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest);
  const { accessToken } = accessTokenResponse;
  localStorage.setItem('accessToken', accessToken);
  return accessToken;
};

/**
 * 查詢用戶信息
 * @returns 
 */
export const callMsGraph = async () => {
  const accessToken = await getAadAccessToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append("Authorization", bearer);
  const options = {
    method: "GET",
    headers: headers
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then(response => response.json())
    .catch(error => console.error(error));
};
/**
 * 獲取用戶的頭像
 * @returns 
 */
export const getUserPhoto = async () => {
  const accessToken = await getAadAccessToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append("Authorization", bearer);
  const options = {
    method: "GET",
    headers: headers
  };
  return fetch('https://graph.microsoft.com/v1.0/me/photo/$value', options)
    .then(response => response.json())
    .catch(error => console.error(error));
};

export {
  msalInstance,
  getAadAccessToken
};
